// A related list's header sort and quick filter, for the lists the server
// pages: what is sent, and which columns the server can sort by.

import type { ColumnDef, SortState } from '@olytic/foundation';

import type { RelatedQuery } from './objectsApi';

/** The most rows one related-list request returns (the server's limit). */
export const RELATED_MAX_LIMIT = 200;

export interface RelatedListQuery {
  sort?: SortState | undefined;
  search: string;
}

/** The request's sort and quick filter. */
export function queryParams(query: RelatedListQuery | undefined): Pick<RelatedQuery, 'sort' | 'dir' | 'q'> {
  return {
    ...(query?.sort ? { sort: query.sort.key, dir: query.sort.direction } : {}),
    ...(query?.search.trim() ? { q: query.search } : {}),
  };
}

/**
 * The server sorts by the columns its rows carry. A column shown from
 * something else (a value worked out in the browser) keeps a plain header
 * while the server sorts the list.
 */
export function serverSortable<T>(columns: ColumnDef<T>[], row: T | undefined): ColumnDef<T>[] {
  if (row === undefined || row === null) return columns;
  return columns.map((column) =>
    column.sortable === undefined && !Object.hasOwn(row as object, column.key) ? { ...column, sortable: false } : column,
  );
}
